// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner[data-v-776a000b]{border-radius:50%;border-color:#ed5f8f rgba(0,0,0,.3) rgba(0,0,0,.3);animation:spin-776a000b 1s ease-in-out infinite;-webkit-animation:spin-776a000b 1s ease-in-out infinite}@keyframes spin-776a000b{to{-webkit-transform:rotate(1turn)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
